"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OptionGroup = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _composeClasses = require("../composeClasses");
var _optionGroupClasses = require("./optionGroupClasses");
var _utils = require("../utils");
var _ClassNameConfigurator = require("../utils/ClassNameConfigurator");
var _jsxRuntime = require("react/jsx-runtime");
function useUtilityClasses(disabled) {
    var slots = {
        root: [
            'root',
            disabled && 'disabled'
        ],
        label: [
            'label'
        ],
        list: [
            'list'
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _ClassNameConfigurator.useClassNamesOverride)(_optionGroupClasses.getOptionGroupUtilityClass));
}
/**
 * An unstyled option group to be used within a Select.
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/)
 *
 * API:
 *
 * - [OptionGroup API](https://mui.com/base-ui/react-select/components-api/#option-group)
 */ var OptionGroup = exports.OptionGroup = /*#__PURE__*/ React.forwardRef(function OptionGroup(props, forwardedRef) {
    var _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, other = _object_without_properties(props, [
        "disabled",
        "slotProps",
        "slots"
    ]);
    var Root = (slots === null || slots === void 0 ? void 0 : slots.root) || 'li';
    var Label = (slots === null || slots === void 0 ? void 0 : slots.label) || 'span';
    var List = (slots === null || slots === void 0 ? void 0 : slots.list) || 'ul';
    var classes = useUtilityClasses(disabled);
    var rootProps = (0, _utils.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState: props,
        className: classes.root
    });
    var labelProps = (0, _utils.useSlotProps)({
        elementType: Label,
        externalSlotProps: slotProps.label,
        ownerState: props,
        className: classes.label
    });
    var listProps = (0, _utils.useSlotProps)({
        elementType: List,
        externalSlotProps: slotProps.list,
        ownerState: props,
        className: classes.list
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, _object_spread_props(_object_spread({}, rootProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, _object_spread_props(_object_spread({}, labelProps), {
                children: props.label
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(List, _object_spread_props(_object_spread({}, listProps), {
                children: props.children
            }))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? OptionGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: _propTypes.default.node,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * If `true` all the options in the group will be disabled.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * The human-readable description of the group.
   */ label: _propTypes.default.node,
    /**
   * The props used for each slot inside the Input.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        label: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        list: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the OptionGroup.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: _propTypes.default.shape({
        label: _propTypes.default.elementType,
        list: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    })
} : void 0;
